const renderToastifyMessage = (text, duration = 2000, background = "#ffffff", color = "#000000") => {
  Toastify({
    text: text,
    duration: duration,
    gravity: "top",
    position: "center",
    style: {
      background: background,
      color: color,
      margin: "auto",
      padding: "20px"
    },
  }).showToast();
}

export default renderToastifyMessage;
